export default __webpack_public_path__ + "static/media/logo.41b8be29.svg";